/**
planroute.service 
*/

/**
url.provider // urlbuilder ? urlbuilder.service ?
Parameters: 
- options: object {instance, season, access }
season : 'current' || 'next'
access: 'remote' || 'local' 

NOTES:
- if environement:
    - node: use require to load the file 
    - browser: use url 
*/



var indexUrlConfig = {
    prod : {
        url : {
            path: '//app.mecatran.com/utw/ws/planroute',
        }
    },
    preprod : {
            url : {
                path: '//app.mecatran.com/utw-test/ws/planroute',
                // path: '//app.mecatran.com/utw-test/ws/planroute',
        }       
    },
    dev : {
            url : {
                path: '//localhost:8080/utw-dev/ws/planroute',
                // path: '//app.mecatran.com/utw-test/ws/planroute',
        }       
    },
    /*
    dev : {
        url : {
            path: './data'
        }
    }
    */
}



export class PlanRoute {
    constructor(env,instance){
        // =================
        // Private variables 
        // -----------------
        var debug = true,
            _env = env || 'prod',
            _instance  = instance,
            _url = undefined
            //_planner = planner
        ;
        // =================
        // Private functions
        // -----------------
        function init(p){
            try{
                var params = checkParams(p)
                _url = buildUrl(params)
            } catch(e){
                console.log(e);
            }
        }
        
        // delete undefined params
        function checkParams(p){
            var plannerSet = new Set(['google','mobigo','moovit'])
            var params = {};
            if ((p.fromLat === undefined) || isNaN(p.fromLat)) throw new Error('from.latitude is not correctly defined ');
                else params.fromLat = p.fromLat; 
            if ((p.fromLon === undefined) || isNaN(p.fromLon)) throw new Error('longitude is not correctly defined');
                else params.fromLon = p.fromLon;
            if ((p.toLat === undefined) || isNaN(p.toLat)) throw new Error('to.latitude is not correctly defined ');
                else params.toLat = p.toLat;
            if ((p.toLon  === undefined) || isNaN(p.toLon)) throw new Error('to.longitude is not correctly defined ');
                else params.toLon = p.toLon;
            if (p.fromLabel && (typeof p.fromLabel != 'string')) throw new Error('from should be a string label');
                else params.fromLabel = p.fromLabel;
            if (p.toLabel && (typeof p.toLabel != 'string')) throw new Error('to should be a string label');
                else params.toLabel = p.toLabel;
            /*
            if (p.from && ((p.from.lat === '')||(p.from.lng === ''))) {
                console.log('Error: from: lat,lng not defined');
            } else {
                params.from = p.from; 
            }
            if (p.to && ((p.to.lat === '')||(p.to.lng === ''))) {
                console.log('Error: from: lat,lng not defined');
            } else {
                params.to = p.to;
            }
            */
            if (p.date === undefined){
                console.log('Error: date is not defined')
            } else params.date = p.date;
            if (p.time === undefined ){
                console.log('Error: time is not defined')
            } else params.time = p.time;
            if (p.deparr === undefined){
                console.log('Error: deparr is not defined')
            } else params.deparr = p.deparr;
            if (p.optimize === undefined){
                console.log('Error: optimize is not defined')
            } else params.optimize = p.optimize;
            if ((p.planner === undefined) || !plannerSet.has(p.planner) )throw new Error('planner should be one of the plannerset element')
                else params.planner = p.planner;
            return params;
        }
        
        
        function buildUrlParams(p){
            var strParams = '';
            if ('fromLat' in p) strParams += `fromLat=${p.fromLat}&`;
            if ('fromLon' in p) strParams += `fromLon=${p.fromLon}&`;
            if ('toLat' in p) strParams += `toLat=${p.toLat}&`;
            if ('toLon' in p) strParams += `toLon=${p.toLon}&`;
            
            if ('fromLabel' in p) strParams +=   `from=${p.fromLabel}&`;
            if ('toLabel' in p)  strParams +=   `to=${p.toLabel}&`;
            
            if ('time' in p) strParams += `time=${p.time}&`;
            if ('date' in p) strParams +=  `date=${p.date}&`;
            if ('deparr' in p) strParams +=  `deparr=${p.deparr}&`;
            if ('optimize' in p) strParams +=  `optimize=${p.optimize}`;
            if ('planner' in p) strParams += `planner=${p.planner}`
            // strParams += `planner=${_planner}`;
            
            return strParams; 
        }
        
        
        function buildUrl(p){
            var url = '';
            var urlParams = buildUrlParams(p);
            url = [ indexUrlConfig[_env].url.path, _instance ].join('/');
            url = [ url, urlParams ].join('?');
            if (debug){
                console.log('url',url);
            }
            return url;
        }
        
        // ================
        // Public accessors
        // ----------------
        Object.defineProperty(this,'url',{
            get : function(){ return _url}
        });
        
        Object.defineProperty(this,'data',{
            set : function(data){ init(data)}
        });      
    }
}



/*
var instance = 'niort', env='prod';
var d={
    departure:'44.25',
    destination: 'xx',
    time: '12:35',
    date:'2018/10/15'
}
var PlanRoute = require('./planroute.service');
var planRoute = new PlanRoute(env,instance);
planRoute.data = d;
planRoute.url; 
*/